'use client'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined'
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined'
import InsertChartOutlinedOutlinedIcon from '@mui/icons-material/InsertChartOutlinedOutlined'
import LibraryBooksOutlinedIcon from '@mui/icons-material/LibraryBooksOutlined'
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined'
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined'
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined'
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined'
export const accountMenuList = [
  {
    label: 'Dashboard',
    icon: <InsertChartOutlinedOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/dashboard',
  },
  // {
  //   label: 'Dashboard affiliate',
  //   icon: <InsertChartOutlinedOutlinedIcon className="!w-[1em]" />,
  //   path: '/affiliate/dashboard',
  //   isMainBar: true,
  // },
  {
    label: 'Thông tin tài khoản',
    icon: <Person2OutlinedIcon className="!w-[1em]" />,
    path: '/accounts',
    isMainBar: true,
  },

  {
    label: 'Sản phẩm yêu thích',
    icon: <FavoriteBorderOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/wishlist',
    isMainBar: true,
  },
  {
    label: 'Lịch sử đơn',
    icon: <AssignmentOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/orders',
    isMainBar: true,
  },
  {
    label: 'Membership',
    icon: <DiamondOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/membership',
    // isCommingSoon: true,
  },
  {
    label: 'Sổ địa chỉ',
    icon: <FmdGoodOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/addresses',
    isMainBar: true,
  },
  // {
  //   label: 'Ví voucher',
  //   icon: <SellOutlinedIcon className="!w-[1em]" />,
  //   path: '/accounts/voucher',
  // },
  {
    label: 'Đánh giá và phản hồi',
    icon: <ThumbUpOutlinedIcon className="!w-[1em]" />,
    path: '/accounts/feedback',
  },
]

export const menuMobile = [
  {
    label: 'Menu',
    menus: [
      {
        label: 'Cửa hàng',
        path: '/danh-muc-san-pham',
        icon: <StorefrontOutlinedIcon className="!w-[1em]" />,
        commingSoon: false,
        isDropDown: true,
      },
      {
        label: 'Về Hydra',
        path: '/about',
        icon: <MenuBookOutlinedIcon className="!w-[1em]" />,
        commingSoon: false,
        isDropDown: false,
      },
      {
        label: 'Styling',
        path: '/styling',
        icon: <LibraryBooksOutlinedIcon className="!w-[1em]" />,
        commingSoon: false,
        isDropDown: false,
      },
    ],
  },
  {
    label: 'Tài khoản',
    isAuthenticated: true,
    menus: [
      {
        label: 'Dashboard',
        icon: <InsertChartOutlinedOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/dashboard',
      },
      {
        label: 'Thông tin tài khoản',
        icon: <Person2OutlinedIcon className="!w-[1em]" />,
        path: '/accounts',
      },

      {
        label: 'Sản phẩm yêu thích',
        icon: <FavoriteBorderOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/wishlist',
      },
      {
        label: 'Lịch sử đơn',
        icon: <AssignmentOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/orders',
      },
      {
        label: 'Membership',
        icon: <DiamondOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/membership',
        commingSoon: false,
      },
      {
        label: 'Sổ địa chỉ',
        icon: <FmdGoodOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/addresses',
      },
      // {
      //   label: 'Ví voucher',
      //   icon: <SellOutlinedIcon className="!w-[1em]" />,
      //   path: '/accounts/voucher',
      // },
      {
        label: 'Đánh giá và phản hồi',
        icon: <ThumbUpOutlinedIcon className="!w-[1em]" />,
        path: '/accounts/feedback',
      },
    ],
  },
]
